import { render, staticRenderFns } from "./VehicleInspectionReportPDF.vue?vue&type=template&id=870a07fe&scoped=true&"
import script from "./VehicleInspectionReportPDF.vue?vue&type=script&lang=js&"
export * from "./VehicleInspectionReportPDF.vue?vue&type=script&lang=js&"
import style0 from "./VehicleInspectionReportPDF.vue?vue&type=style&index=0&id=870a07fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870a07fe",
  null
  
)

export default component.exports